import { NodeViewContent, NodeViewWrapper, type NodeViewProps } from '@tiptap/react'

/** A grid of link cards, the usual shape of a documentation landing page. */
export function CardsView({ node, editor, getPos }: NodeViewProps) {
  const addCard = () => {
    const pos = getPos?.()
    if (pos === undefined) return
    const end = pos + node.nodeSize - 1
    editor
      .chain()
      .focus()
      .insertContentAt(end, {
        type: 'card',
        attrs: { title: 'New card' },
        content: [{ type: 'paragraph' }],
      })
      .run()
  }
  return (
    <NodeViewWrapper className="be-cards" data-sls="cards">
      <NodeViewContent className="be-cards__grid" />
      {editor.isEditable && (
        <button className="be-cards__add" onClick={addCard} type="button">
          + Card
        </button>
      )}
    </NodeViewWrapper>
  )
}

export function CardView({ node, updateAttributes, editor, getPos }: NodeViewProps) {
  const remove = () => {
    const from = getPos?.()
    if (from === undefined) return
    editor
      .chain()
      .focus()
      .deleteRange({ from, to: from + node.nodeSize })
      .run()
  }
  return (
    <NodeViewWrapper className="be-card" data-sls="card">
      <div className="be-card__head" contentEditable={false}>
        <input
          className="be-inline-input be-inline-input--title"
          value={(node.attrs['title'] as string | null) ?? ''}
          placeholder="Card title"
          disabled={!editor.isEditable}
          onChange={(e) => updateAttributes({ title: e.target.value || null })}
        />
        {editor.isEditable && (
          <button className="be-icon-btn" onClick={remove} type="button" data-tip="Remove card">
            ×
          </button>
        )}
      </div>
      <input
        className="be-inline-input be-inline-input--href"
        value={(node.attrs['href'] as string | null) ?? ''}
        placeholder="Link, e.g. /getting-started/intro"
        disabled={!editor.isEditable}
        onChange={(e) => updateAttributes({ href: e.target.value || null })}
      />
      <NodeViewContent className="be-card__body" />
    </NodeViewWrapper>
  )
}
